//Código para abrir e fechar o menu com o hover do mouse

// Seleciona o contêiner que inclui todos os elementos <details>
let menuContainer = document.querySelector('.header__inline-menu');

// Adiciona um ouvinte de eventos para toda a área do menu
menuContainer.addEventListener('mouseover', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.setAttribute('open', true);
  }
});

menuContainer.addEventListener('mouseout', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.removeAttribute('open');
  }
});

// Gerencia os eventos de foco e blur usando delegação de eventos
menuContainer.addEventListener('focusin', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.setAttribute('open', true);
  }
});

menuContainer.addEventListener('focusout', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.removeAttribute('open');
  }
});

// Ouvinte de eventos para a área de submenu para fechar todos os <details> quando o mouse sai
let dropdownItems = document.querySelector('.header__submenu');
if (dropdownItems) {
  dropdownItems.addEventListener('mouseleave', () => {
    document.querySelectorAll('.header__inline-menu details[open]').forEach((item) => {
      item.removeAttribute('open');
    });
  });
}

//Fim do Código para abrir e fechar o menu com o hover do mouse

// --------- Código para clonar ícone do carrrinho no upcart

document.addEventListener('DOMContentLoaded', function () {
  var originalIcon = document.querySelector('.header__icon--cart > svg, .header__icon--cart > img');

  // Função para clonar e inserir o ícone
  function cloneAndInsertIcon(targetDiv) {
    if (originalIcon && targetDiv) {
      var clonedIcon = originalIcon.cloneNode(true);
      if (targetDiv.firstChild) {
        targetDiv.insertBefore(clonedIcon, targetDiv.firstChild);
      } else {
        targetDiv.appendChild(clonedIcon);
      }
      console.log('Ícone clonado e inserido com sucesso');
    }
  }

  // Observa mudanças no corpo do documento
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.from(mutation.addedNodes).forEach(function (node) {
        // Verifica se o nó é um elemento e tem a classe 'upcart-header'
        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('upcart-header')) {
          cloneAndInsertIcon(node);
        }

        // Verifica também dentro de qualquer nó adicionado se há 'upcart-header'
        if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('.upcart-header')) {
          cloneAndInsertIcon(node.querySelector('.upcart-header'));
        }
      });
    });
  });

  // Inicia a observação
  observer.observe(document.body, { childList: true, subtree: true });

  // Verifica inicialmente se o elemento já está presente
  var targetDiv = document.querySelector('.upcart-header');
  if (targetDiv) {
    cloneAndInsertIcon(targetDiv);
  }
});

// --------------- Fim do Código para clonar ícone do carrrinho no upcart
